export const leagueLogos = {
  pl: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/epl_compact.png',
    logoWhite: '',
    alt: 'Premier League',
    height: null,
  },
  seriea: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/serie_a.jpg',
    logoWhite: '',
    alt: 'Serie A',
    height: null,
    url: '/ca/serie-a/',
  },
  coppaitalia: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/coppa_italia.png',
    logoWhite: '',
    alt: 'Copppa Italia',
    height: null,
    url: '/ca/coppa-italia-serie-a/',
  },
  laliga: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/LaLiga-2.png',
    logoWhite: '',
    alt: 'La Liga',
    height: null,
    url: '/la-liga-on-espn-deportes/',
  },
  liga_portugal: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/LigaPortugal-2.png',
    logoWhite: '',
    alt: 'La Liga Portugal',
    height: null,
  },
  betplay: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/Betplay-2.png',
    logoWhite: '',
    alt: 'Betplay',
    height: null,
    url: '/la/liga-betplay-di-mayor/',
  },
  seriea_w_network: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/SerieA-2.png',
    logoWhite: '',
    alt: 'Serie A',
    height: null,
    url: '/ca/serie-a/',
  },
  bundesliga: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/Bundesliga-2.png',
    logoWhite: '',
    alt: 'Bundesliga',
    height: null,
  },
  liberatores: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/Liberatores.png',
    logoWhite: '',
    alt: 'Liberatores',
    height: null,
  },
  ligaMX: {
    logoUrl: 'https://assets-imgx.fubo.tv/marketing/lp/images/leagues/ligaMx-1.png',
    logoWhite: '',
    alt: 'Liga MX',
    height: null,
    url: '/liga-mx/',
  },
}
